// SCRIPTS
export default {
  dataSynced: state => {
    return !state.data_syncing;
  },
  selectedDay: state => {
    return state.selected_day;
  }
};
